'use client';

import { useParams, useRouter } from 'next/navigation';
import React, { FC } from 'react';

import { GameType } from '@/api/services/GameService/types';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

export interface GameCardProps {
  game: GameType;
}

const GameCard: FC<GameCardProps> = ({ game }) => {
  const params = useParams();
  const { t } = useTranslation();
  const router = useRouter();
  const isMobile = useDeviceSize();

  return (
    <div
      className="gameListItem"
      onClick={() => {
        if ((isMobile && game.status === 1) || game.id === 146)
          router.push(`/${params.lang}/products/games/${game.categorySlug}/${game.slug}`);
      }}
    >
      <div
        className="gameListImgWrp"
        style={
          {
            '--cardColor': game.pageColor?.match(/\d+/g)?.join(', ') || 'default-color',
          } as React.CSSProperties
        }
      >
        <Image
          alt={game.alt || ''}
          src={game.logo}
          width={500}
          height={500}
          className="gameListImg"
        />
      </div>
      <div
        className="gameListItemInfoHolderWrp"
        style={
          {
            '--cardColor': game.pageColor?.match(/\d+/g)?.join(', ') || 'default-color',
          } as React.CSSProperties
        }
      >
        <div className="gameListItemInfoHolder">
          <div className="gameListInfo">
            <div className="gameListInfoTitleContainer">
              <h3 className="gameListInfoTitle">{game.name}</h3>
            </div>
            <div className="gameListInfoDetailsContainer">
              <div className="gameListInfoDetailItems">
                <p className="detailText">{game.rtp}</p>
                <div className="detailDescriptionWrp">
                  <p className="detailDescription" title={t('Games-Description-RTP')}>
                    {t('Games-Description-RTP')}
                  </p>
                </div>
              </div>
              <div className="gameListInfoDetailItems">
                <p className="detailText">{game.maxMultiplier}</p>
                <div className={'detailDescriptionWrp'}>
                  <p className="detailDescription" title={t('Games-Description-Max Multiplier')}>
                    {t('Games-Description-Max Multiplier')}
                  </p>
                </div>
              </div>
              <div className="gameListInfoDetailItems">
                <p className="detailText">{game.low}</p>
                <div className={'detailDescriptionWrp'}>
                  <p className="detailDescription">{t('Games-Feature-Title')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="gameListDetailButtonWrp">
            {game.status === 1 || game.id === 146 ? (
              <Link
                id={`${game.id}`}
                href={`/${params.lang}/products/games/${game.categorySlug}/${game.slug}`}
                className="button btnTypeMedium btnTypeCopy fullWidth"
              >
                <p className="mobBtnTxt">{t('Poly-Button-Livecasinogames')}</p>
                <i className="bc-i-go-to btnIcon btnIconSmall" />
              </Link>
            ) : (
              <button className={'button btnTypeMedium btnTypeCopy fullWidth'}>
                <p className="mobBtnTxt">{t('COMING-SOON')}</p>
                <i className="bc-i-go-to btnIcon btnIconSmall" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCard;
